var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRightSm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.46678 14.553H17.8921L13.3374 19.1077C12.9734 19.4717 12.9734 20.069 13.3374 20.433C13.7014 20.797 14.2894 20.797 14.6534 20.433L20.8041 14.2823C21.1681 13.9183 21.1681 13.3303 20.8041 12.9663L14.6628 6.80632C14.4884 6.63155 14.2517 6.53333 14.0048 6.53333C13.7579 6.53333 13.5212 6.63155 13.3468 6.80632C12.9828 7.17032 12.9828 7.75832 13.3468 8.12232L17.8921 12.6863H7.46678C6.95345 12.6863 6.53345 13.1063 6.53345 13.6197C6.53345 14.133 6.95345 14.553 7.46678 14.553Z",
    fill: "#8C99B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightSm);
export default __webpack_public_path__ + "static/media/arrow_right-sm.606329ce6a9aff13315dec2b07d4c4ec.svg";
export { ForwardRef as ReactComponent };